import { useSortBy, UseSortByProps } from 'react-instantsearch';

export const SortByVirtual = (props: UseSortByProps) => {
  useSortBy(props);
  return null;
};
